export default __webpack_public_path__ + "static/uniswap-b26fd45eacb74a82fe9351ae0929631c.png";